import React from "react";
import styled, { css } from "styled-components";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLocationPinLock,
  faEnvelope,
  faMicrophone,
} from "@fortawesome/free-solid-svg-icons";

const Contact = () => {
  const [portrait, setPortrait] = React.useState(false);
  React.useEffect(() => {
    setInterval(() => { 
      if (window.innerWidth > window.innerHeight) {
        setPortrait(false);
      } else if (window.innerWidth <= window.innerHeight) {
        setPortrait(true);
      }
    }, 250);
  }, []);
  return (
    <>
      {portrait === false ? (
        <ContactWrapper id="contact">
          <ContactSentence>Culpa perferendis excepturi.</ContactSentence>
          <ContactTitle>Contact Us</ContactTitle>
          <ContactGrid>
            <ContactForm>
              <input placeholder="Name" />
              <input style={{ marginLeft: "0.25vw" }} placeholder="Email" />
              <br />
              <textarea placeholder="Your Message" />
              <br />
              <button>Send Message</button>
            </ContactForm>
            <ContactInfo>
              <CITitle>Contact Info</CITitle>
              <CIContent>
                Contact us and we'll get back to you within 24 hours.
              </CIContent>
              <CIContent>
                <FontAwesomeIcon icon={faLocationPinLock} />
                <> </>
                12345 Fake ST NoWhere AB Country
              </CIContent>
              <CIContent>
                <FontAwesomeIcon icon={faEnvelope} />
                <> </>info@domain.com
              </CIContent>
              <CIContent>
                <FontAwesomeIcon icon={faMicrophone} />
                <> </> (123) 456-7890
              </CIContent>
            </ContactInfo>
          </ContactGrid>
          <ContactFooter>Copyright 2045 © DevZiejson</ContactFooter>
        </ContactWrapper>
      ) : (
        <ContactWrapper id="contact">
          <ContactSentence>Culpa perferendis excepturi.</ContactSentence>
          <ContactTitle>Contact Us</ContactTitle>
          <ContactGrid>
            <ContactForm>
              <input placeholder="Name" />
              <input style={{ marginLeft: "0.25vw" }} placeholder="Email" />
              <br />
              <textarea placeholder="Your Message" />
              <br />
              <button>Send Message</button>
            </ContactForm>
          </ContactGrid>
          <ContactFooter>Copyright 2045 © DevZiejson</ContactFooter>
        </ContactWrapper>
      )}
    </>
  );
};

const ContactWrapper = styled.div`
  width: 100vw;
  height: 94vh;
  overflow: hidden;
`;

const ContactGrid = styled.div`
  width: 100vw;
  display: grid;
  grid-template-columns: repeat(2, 1fr);

  @media screen and (orientation : portrait) {
    display : flex;
    justify-content: center;
    align-items: center;
  }
`;

const ContactInfo = styled.div`
  width: 22vw;
  height: 35vh;
  margin-top: 5vh;
`;

const CITitle = styled.h1`
  font-size: 1.25vw;
  height: 2vw;
  color: black;
  margin: 0;
  font-weight: 500;
  position: relative;
  width: 16vw;
  margin-top: 1vw;
  margin-left: 5vw;

  ::after {
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    opacity: 0.6;
    height: 0.05vw;
    background-color: grey;
  }
`;

const CIContent = styled.h1`
  font-size: 1.1vw;
  color: black;
  margin: 0;
  font-weight: 300;
  width: 17vw;
  margin-top: 1vw;
  margin-left: 5vw;
`;

const ContactSentence = styled.h1`
  margin: 0;
  color: gray;
  font-size: 0.9vw;
  font-weight: 400;
  margin-left: 15vw;
  padding-top: 8vw;

  @media screen and (orientation: portrait) {
    max-width: 100vw;
    font-size: 1.75vh;
    margin-left: 5vw;
    padding-top : 16vw;
  }
`;
const ContactTitle = styled.h1`
  margin: 0;
  font-size: 2vw;
  color: black;
  font-weight: 500;
  margin-left: 15vw;

  @media screen and (orientation: portrait) {
    max-width: 100vw;
    font-size: 4.25vh;
    margin-left: 5vw;
  }
`;

const ContactForm = styled.form`
  width: 40vw;
  height: 45vh;
  margin-left: 15vw;
  margin-top: 5vh;

  input {
    width: 19vw;
    height: 4vh;
  }

  textarea {
    width: 38.25vw;
    height: 25vh;
    margin-top: 1vw;
  }

  input,
  textarea {
    background-color: rgba(0, 0, 0, 0.03);
    box-sizing: border-box;

    outline: none;
    transition: border 150ms;
    will-change: border;

    border-radius: 0.25vw;
    border: solid grey 0.1vw;
    font-size: 1.1vw;

    ::placeholder {
      font-weight: 300;
    }

    :placeholder-shown {
      padding-left: 0.5vw;
    }

    :focus {
      border: solid #f07069 0.2vw;
    }
  }

  button {
    width: 38.25vw;
    height: 2.5vw;
    font-size: 1.1vw;
    border: none;
    color: white;
    cursor: pointer;
    background-color: #f53b4d;
    margin-top: 1vw;

    transition: background-color 300ms;

    :hover {
      background-color: #ed1f32;
    }
  }

  @media screen and (orientation : portrait) {
    width : 95vw;
    margin-left : 2.5vw;

    input {
      width : 45vw;
      font-size : 1.55vh;
    }

    textarea {
      width : 90vw;
      max-width : 90vw;
      font-size : 1.4vh;
    }

    input,textarea {
      border-radius : 0.5vh;
    }

    button {
      width : 90vw;
      height : 4vh;
      font-size : 1.5vh;
    }
  }
`;

const ContactFooter = styled.h1`
  margin: 0;
  font-size: 1vw;
  width: 70vw;
  margin-left: 15vw;
  font-weight: 300;
  color: grey;
  position: relative;
  padding-top: 3vw;

  ::before {
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    opacity: 0.8;
    height: 0.05vw;
    background-color: grey;
  }

  @media screen and (orientation : portrait) {
    width : 90vw;
    margin-left : 5vw;
    font-size : 2vh;
  }
`;

export default Contact;
